import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { ServicesSection } from '../components/ServicesSection';
import { NichesSection } from '../components/NichesSection';
import { ProcessSteps } from '../components/ProcessSteps';
import { AdvantagesSection } from '../components/AdvantagesSection';
import { CeoSection } from '../components/CeoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BlogSection } from '../components/BlogSection';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-white" data-id="element-734">
      <Header data-id="element-735" />
      <main data-id="element-736">
        <HeroSection data-id="element-737" />
        <AchievementsSection data-id="element-738" />
        <ServicesSection data-id="element-739" />
        <NichesSection data-id="element-740" />
        <ProcessSteps data-id="element-741" />
        <AdvantagesSection data-id="element-742" />
        <CeoSection data-id="element-743" />
        <TestimonialsSection data-id="element-744" />
        <BlogSection data-id="element-745" />
        <ContactForm data-id="element-746" />
      </main>
      <Footer data-id="element-747" />
    </div>;
}